export default __webpack_public_path__ + "static/media/add-point-restricted.b551792c.svg";